import { Typography, Container } from "@cleartrip/ct-design-components";
import { FunctionComponent } from "react";
import { BadgeProps } from "./types";
import Image from "next/image";
import classNames from "classnames";

const Badge: FunctionComponent<BadgeProps> = (props) => {
  const {
    text,
    type = "macro",
    backgroundColor = "#1A1A1A",
    maxWidth = "100%",
    textColor = "#ffffff",
    image,
    wrapperClass = "",
  } = props;

  const containerClassName = classNames("px-1", wrapperClass);
  return (
    <Container
      css={{ maxWidth: maxWidth }}
      className={containerClassName}
      backgroundColor={backgroundColor}
      borderRadius={"4px"}
    >
      <Container className="flex flex-middle flex-center h-100p">
        {image ? (
          <Image
            style={{ marginRight: "2px" }}
            height={12}
            width={12}
            src={image}
            alt="icon"
          />
        ) : null}
        <Typography
          variant={type === "micro" ? "B4" : "B3"}
          colorCode={textColor}
        >
          {text}
        </Typography>
      </Container>
    </Container>
  );
};

export default Badge;
